import { InjectionToken } from '@angular/core';

export const i18nConfigService = new InjectionToken<any>('i18nConfig');
